import { useSyncExternalStore } from 'react';

let hasUnread = false;
let hasUnreadChats = false;
const subscribers = new Set<() => void>();

function notify(): void {
	subscribers.forEach((fn) => fn());
}

function subscribe(fn: () => void): () => void {
	subscribers.add(fn);
	return () => {
		subscribers.delete(fn);
	};
}

function getSnapshot(): boolean {
	return hasUnread;
}

function getUnreadChatsSnapshot(): boolean {
	return hasUnreadChats;
}

export function setHasUnread(value: boolean): void {
	if (value === hasUnread) return;

	hasUnread = value;
	notify();
}

export function setHasUnreadChats(value: boolean): void {
	if (value === hasUnreadChats) return;

	hasUnreadChats = value;
	notify();
}

export function resetNotifications(): void {
	setHasUnread(false);
	setHasUnreadChats(false);
}

export function useHasUnreadNotifications(): boolean {
	return useSyncExternalStore(subscribe, getSnapshot);
}

export function useHasUnreadChats(): boolean {
	return useSyncExternalStore(subscribe, getUnreadChatsSnapshot);
}
